export const DAYS_IN_WEEK = 7
export const MONTHS_IN_YEAR = 12
